import axios from 'axios';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LETTER_POSTBOXES_URL } from '../../../constants/paths/api';
import { Input } from '../../base/forms/input';
import * as StyledLetterPostboxes from './letterPostboxes.styles';
import LetterPostboxesTable from './letterPostboxesTable';

interface Props {
	active: boolean;
}

const LetterPostboxes: FC<Props> = ({ active }) => {
	const [value, setValue] = useState('');
	const [data, setData] = useState(null);
	const [filteredData, setFilteredData] = useState(null);
	const { t } = useTranslation('generalPostInfo');

	const onChange = async e => {
		try {
			setValue(e.target.value);
			const lowerCaseValue = e.target.value.toLowerCase();
			const filtered = data.filter(postbox => {
				if (
					postbox.postCode.toString().indexOf(lowerCaseValue) !== -1 ||
					postbox.name.toLowerCase().indexOf(lowerCaseValue) !== -1 ||
					postbox.address.toLowerCase().indexOf(lowerCaseValue) !== -1 ||
					postbox.city.toLowerCase().indexOf(lowerCaseValue) !== -1
				) {
					return true;
				}
				return false;
			});
			setFilteredData(filtered);
		} catch (err) {
			console.log(err);
		}
	};

	useEffect(() => {
		if (!data && active) {
			axios(`${LETTER_POSTBOXES_URL}`).then(homeAndCompaniesData => {
				setData(homeAndCompaniesData.data);
			});
		}
		// this is done so postboxes are sorted by postCode,
		// this was not done before and lead to 107 postcode being randomly placed between 800 postcodes
		if (data) {
			const filtered = data
				?.filter(postbox => {
					if (
						postbox.postCode.toString().indexOf(value) !== -1 ||
						postbox.name.toLowerCase().indexOf(value) !== -1 ||
						postbox.address.toLowerCase().indexOf(value) !== -1 ||
						postbox.city.toLowerCase().indexOf(value) !== -1
					) {
						return true;
					}
					return false;
				})
				.sort((a, b) => a.postCode - b.postCode);
			setFilteredData(filtered);
		}
	}, [data, setData, active, value]);

	return (
		<StyledLetterPostboxes.Wrapper>
			<StyledLetterPostboxes.InputWrapper>
				<Input type="text" value={value} onChange={onChange} placeholder={`${t('address-search.search')}...`} />
			</StyledLetterPostboxes.InputWrapper>
			<StyledLetterPostboxes.TableWrapper>
				<LetterPostboxesTable data={filteredData || data} />
			</StyledLetterPostboxes.TableWrapper>
		</StyledLetterPostboxes.Wrapper>
	);
};

export default LetterPostboxes;
